import { render } from "./EventStateEditor.vue?vue&type=template&id=1c56653f&ts=true"
import script from "./EventStateEditor.vue?vue&type=script&lang=ts"
export * from "./EventStateEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__